export default __webpack_public_path__ + "alberta-cross-therapy.375f43208546ef8f606f.svg";